import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IAddon } from "../../models/Addon";
import { AddonService } from "../../services/addon.service";
import { CountryService } from "../../services/country.service";
import { ICountry } from "../../models/Country";
import useAppDispatch from "../../hooks/useAppDispatch";
import { setAllCountries } from "../../store/countries/countriesSlice";

export const useGetAllCountriesQuery = () => {
  const dispatch = useAppDispatch();
  return useQuery<ICountry[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_COUNTRIES],
    queryFn: () =>
      CountryService.getCountries().then((res) => {
        dispatch(setAllCountries(res.data));
        return res.data;
      }),
  });
};
